<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getHintList)" class="refresh-btn">刷新</el-button>
    <div slot="content" class="detailswrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="日常随访">
            <el-input v-model="searchForm.content" clearable placeholder="请输入日常随访关键字" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getHintList, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getHintList, { content: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addHint">新增日常随访</el-button>
        <el-button icon="el-icon-delete" type="danger" @click="deleteHintList">批量删除</el-button>
      </div>
      <div>
        <!-- 日常随访列表 -->
        <el-table v-loading="loading" :data="hintList" ref="multipleTable" :max-height="tableHeight"
          @selection-change="val => $handleSelectionChange(val, true)" border>
          <el-table-column type="selection" width="50" />
          <el-table-column prop="content" label="日常随访内容" min-width="300">
            <template slot-scope="scope">
              <div v-html="scope.row.contentStr"></div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button icon="el-icon-edit" type="primary" @click="editHint(scope.row)">编辑</el-button>
              <el-button icon="el-icon-delete" type="danger" @click="deleteHint(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination class="mt20" @current-change="page => $handleCurrentChange(page, getHintList)" :total="total"
          :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
      </div>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="hintEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="500px"
        :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" label-width="110px" :rules="editFormRules" inline>
          <el-form-item label="日常随访内容" prop="content">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" resize="none" v-model="editForm.content"
              placeholder="请输入日常随访内容" />
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增日常随访'" @click="addSave(editForm)">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑日常随访'" @click="editSave(editForm)">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script lang="js">
import { hintBankList, hintBankEdit, hintBankDelete, hintBankAdd } from "@/api/followup-questionnaire"; // 获取问卷请求
export default {
  name: "templates",
  data() {
    return {
      loading: true, // 加载中
      hintList: [], // 日常随访列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      searchForm: { content: null }, // 查询表单
      multipleSelection: [], // 被选中行
      dialogVisible: false, // 新增或编辑弹框状态
      dialogTitle: null, // 弹框标题
      editForm: {}, // 新增或编辑表单
      editFormRules: {
        content: [{ required: true, message: "日常随访内容不能为空！" }],
      }, // 验证规则
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320; // 计算表格最大高度
    this.getHintList(); // 请求日常随访列表
  },
  methods: {
    // 请求日常随访列表
    async getHintList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { rows, code, total } = await hintBankList(params);
      if (code == 200) {
        rows.forEach(item => {
          item.contentStr = ('<p>' + item.content + '</p>').replace('\n', '</p><p>');
        })
        this.hintList = rows;
        this.total = total;
      }
      this.loading = false;
    },
    // 新增提示
    addHint() {
      this.dialogVisible = true;
      this.dialogTitle = "新增日常随访";
      this.editForm = { content: null };
    },
    // 保存新增
    addSave(obj) {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          hintBankAdd(obj).then(res => {
            let { code } = res;
            if (code == 200) this.$message.success("新增日常随访成功！");
            this.dialogVisible = false;
            this.$refresh(this.getHintList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 编辑日常随访信息
    editHint(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.dialogTitle = "编辑日常随访";
      this.dialogVisible = true;
    },
    // 保存日常随访修改
    editSave(obj) {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          hintBankEdit(obj).then(res => {
            if (res.code == 200) this.$message.success("修改日常随访成功！");
            this.dialogVisible = false;
            this.$refresh(this.getHintList);
            this.$refs['editForm'].resetFields();
          });
        } else return false;
      })
    },
    // 删除日常随访
    deleteHint(row) {
      this.$confirm('确认删除该日常随访？').then(_ => { this.del(row.examHintMessageTemplate) }).catch(_ => { });
    },
    async del(id) {
      let { code } = await hintBankDelete(id);
      if (code == 200) this.$message.success("删除日常随访成功！");

      this.$refresh(this.getHintList);
    },
    // 批量删除日常随访
    deleteHintList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何日常随访");
      else {
        selected.forEach(item => { selectedId.push(item.examHintMessageTemplate) });
        this.$confirm('确认删除该日常随访？').then(_ => { this.del(selectedId) }).catch(_ => { });
      }
    }
  },
};
</script>

<style lang="less" scoped>
.detailswrap {
  &>div:not(:last-child) {
    margin-bottom: 20px;
  }

  /* 日常随访列表样式 */
  .el-table {
    border: 1px solid #e6e6e6;
    border-bottom: 0;

    /deep/p {
      line-height: 20px;
      text-indent: 2em;
    }

    .el-form {
      margin-left: 40px;

      .el-form-item {
        margin-bottom: 0;

        &.option {
          /deep/.el-form-item__content {
            display: flex;
            flex-wrap: wrap;
            padding-left: 0;

            div {
              width: 400px;
            }
          }
        }

        /deep/.el-form-item__content {
          font-size: 12px;
          line-height: 24px;
          padding-left: 72px;


        }

        /deep/.el-form-item__label {
          color: #999;
          font-size: 12px;
          line-height: 24px;
        }
      }
    }
  }

  /* 日常随访模态框样式 */
  .hintEdit {
    .option {
      .option-wrap {
        border: 1px solid #e6e6e6;
        padding: 5px;
        margin-bottom: 10px;

        /deep/.el-form-item__label {
          width: 60px !important;
        }
      }
    }

    .el-form {
      .el-form-item {
        margin-right: 0;
        display: flex;

        /deep/.el-form-item__content {
          flex: 1;

          .el-select {
            width: 100%;
          }
        }
      }
    }
  }
}</style>